import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED, IS_VALID_HEX_CODE } = validators;
    const errors = {};
    if (IS_VALID_HEX_CODE(values.primaryColor)) {
        errors.primaryColor = 'Please Enter Valid Hex Code';
    }
    if (REQUIRED(values.theme)) {
        errors.theme = 'Please select theme';
    }
    return errors;
};

export default validate;
